import '@chillibean/component-library/index.css';

import { ToastNotifications } from '@chillibean/component-library';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Provider } from 'react-redux';

import { GlobalStyle } from '../../assets';
import { LibraryAssetContainer } from './components/container';
import { setInternal } from './redux/internal.slice';
import setupStore from './redux/store';

function LibraryAsset(props) {
  const { accountId, assetId, libraryId, user, authenticityToken } = props;
  const [store] = useState(setupStore());

  useEffect(() => {
    const internalValues = {
      accountId: accountId,
      assetId: assetId,
      authenticityToken: authenticityToken,
      libraryId: libraryId,
      user: user,
    };

    store.dispatch(setInternal(internalValues));
  }, []);

  return (
    <>
      <GlobalStyle />
      <Provider store={store}>
        {/* TODO: asset_layout.html.erb requires refactor  */}
        <div style={{ marginLeft: '-270px' }}>
          <ToastNotifications />
        </div>
        <LibraryAssetContainer />
      </Provider>
    </>
  );
}

LibraryAsset.propTypes = {
  authenticityToken: PropTypes.string.isRequired,
  accountId: PropTypes.number.isRequired,
  assetId: PropTypes.number.isRequired,
  libraryId: PropTypes.number.isRequired,
  user: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
};

export default LibraryAsset;
